import { useRouter } from "next/router";

import { Row } from "antd";
import useTranslation from "next-translate/useTranslation";

import ContentPreview from "pages/[tenant]/courses/modules/CourseLandingPage/components/ContentSections/components/ContentPreview";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import Reviews from "shared/components/organisms/Reviews";
import { useFeature } from "shared/utils/hooks/useFeature";

import AboutAuthor from "./components/AboutAuthor";
import Bundles from "./components/Bundles";
import Certificate from "./components/Certificate/render";
import Comments from "./components/Comments";
import Description from "./components/Description";
import InfoSections from "./components/InfoSections";
import OthersCourses from "./components/OthersCourses";
import Play from "./components/Play";
import Resourcers from "./components/Resourcers";
import Warranty from "./components/Warranty";
import { ColContent, ColPlay, Container } from "./styles";

const ContentSections = ({ course, reviews, courses }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const isCertificateEnabled = useFeature("f_certifcates");
  const isProductBundlesEnabled = useFeature("f_product_bundles");
  const isCoursesEnabled = useFeature("f_courses");

  if (!isCoursesEnabled) router.push("/404");

  return (
    <Container>
      <div className="width-limiter">
        <div id="course-landing-content" className="gx-profile-content">
          <Row>
            <ColPlay>
              <div className="sticky-container">
                <ComponentErrorBoundary>
                  <Play course={course} />
                </ComponentErrorBoundary>

                {!course?.has_enrollment && course.satisfaction_guarantee && (
                  <ComponentErrorBoundary>
                    <Warranty />
                  </ComponentErrorBoundary>
                )}

                {course?.allow_certificate && isCertificateEnabled && (
                  <ComponentErrorBoundary>
                    <Certificate
                      course={course}
                      hasEnrollment={course?.has_enrollment}
                      allowCertificate={course?.allow_certificate}
                      certificateEnabled={course?.certificate_enabled}
                    />
                  </ComponentErrorBoundary>
                )}
              </div>
            </ColPlay>

            <ColContent>
              <ComponentErrorBoundary>
                <Description course={course} />
              </ComponentErrorBoundary>

              <ComponentErrorBoundary>
                <Resourcers course={course} />
              </ComponentErrorBoundary>

              <ComponentErrorBoundary>
                <InfoSections course={course} />
              </ComponentErrorBoundary>

              <ComponentErrorBoundary>
                <ContentPreview course={course} />
              </ComponentErrorBoundary>

              <ComponentErrorBoundary>
                <AboutAuthor course={course} />
              </ComponentErrorBoundary>

              <ComponentErrorBoundary>
                {isProductBundlesEnabled && <Bundles course={course} />}
              </ComponentErrorBoundary>

              <ComponentErrorBoundary>
                <OthersCourses course={course} courses={courses} />
              </ComponentErrorBoundary>

              <ComponentErrorBoundary>
                {course.status_reviews && (
                  <Reviews
                    course={course}
                    reviews={reviews}
                    sectionTitle={t("common:studentFeedback")}
                  />
                )}
              </ComponentErrorBoundary>

              <ComponentErrorBoundary>
                {course?.status_comments && <Comments course={course} />}
              </ComponentErrorBoundary>
            </ColContent>
          </Row>
        </div>
      </div>
    </Container>
  );
};

export default ContentSections;
